<template>
  <div class="p-3">
    <a-table
      class="table datatable thead-light"
      :columns="columns"
      :data-source="rows"
      :loading="loading"
      row-key="id"
      :row-selection="rowSelection"
    >
      <template #bodyCell="{ column, record }">
       
        <template v-if="column.key === 'type'">
          {{
            record?.type ||
            "-"
          }}
        </template>

        

        <template v-else-if="column.key === 'description'">
          {{
            record?.description ||
            "-"
          }}
        </template>
         <template v-if="column.key === 'status'">
        <span
          class="d-inline-flex align-items-center badge-xs"
          :class="[
            'badge',
            record.status === 'Active' ? 'badge-success' : 'badge-danger',
          ]"
        >
          <i class="ti ti-point-filled me-1"></i>{{ record.status }}
        </span>
      </template>

        <template v-else-if="column.key === 'action'">
          <div class="action-icon d-inline-flex">
            <a
              href="javascript:void(0);"
              class="me-2"
              @click="$emit('edit', record)"
              v-can="'TrainingType.Edit'"
            >
              <i class="ti ti-edit"></i>
            </a>
            <a href="javascript:void(0);" @click="$emit('delete', record)" v-can="'TrainingType.Delete'">
              <i class="ti ti-trash"></i>
            </a>
          </div>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});
const emit = defineEmits(["edit", "delete", "bulk-delete"]);

const selectedRowKeys = ref([]);

const columns = [
  { title: "Type", dataIndex: "type", key: "type" },
  
  { title: "Description", dataIndex: "description", key: "description" },
  { title: "", dataIndex: "action", key: "action" },
  { title: "Status", dataIndex: "status", key: "status" },
  { title: "", dataIndex: "action", key: "action" },
];

const rowSelection = {
  selectedRowKeys: selectedRowKeys.value,
  onChange: (keys) => {
    selectedRowKeys.value = keys;
  },
  onSelect: () => {},
  onSelectAll: () => {},
};


window.addEventListener("keydown", (e) => {
  if (e.key === "Delete" && selectedRowKeys.value.length) {
    emit("bulk-delete", selectedRowKeys.value);
  }
});
</script>
